export default __webpack_public_path__ + "static/media/menu10_hl.1e9568b5.png";